import { render, staticRenderFns } from "./FirstLaunchDialog.vue?vue&type=template&id=47d04bee"
import script from "./FirstLaunchDialog.vue?vue&type=script&lang=js"
export * from "./FirstLaunchDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports